// CommitChart.js
import { Doughnut } from 'vue-chartjs';
import ColorsMixin from '../mixins/ChartColorsMixin';

let options = {
    responsive: true,
    cutoutPercentage: 35,
    rotation: Math.PI,
    circumference: Math.PI,
    animation: {
        animateScale: true,
        animateRotate: false
    },
    tooltips: {
        enabled: false
    },
    hover: {mode: null}
};

export default Doughnut.extend({

    mixins: [ ColorsMixin ],

    props: ['impact'],
    
    mounted () {
        let vm = this;

        // Overwriting base render method with actual data.
        setTimeout(function(){
            vm.renderChart(vm.data, options);
        }, 1500);
    },

    computed: {
        data()  {
            return {
                datasets: [
                    {
                        label: '',
                        backgroundColor: this.colorsArray,
                        data: [1, 1, 1, 1, 1]
                    },
                ]
            }
        },

        /**
         * Generate array of colors for the graph based on imput numbers
         *
         * @returns {Array}
         */
        colorsArray() {
            let vm = this;
            let output = [];

            for (let i = 0; i <= 4; i++) {

                if (Math.round(vm.impact) === i + 1) {
                    output.push(vm.activeColors[i]);
                } else {
                    output.push(vm.pasiveColors[i]);
                }

            }

            return output;
        }
    }
})